import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { AuthService } from '../../services/auth.service';
import { StrapiGenericComponentService } from './../../services/strapi-generic-component.service';
import { DidThisHelpComponent } from './did-this-help.component';
import { ConfirmationModule } from '../confirmation/confirmation.module';
import { YesNoCtaModule } from '../yes-no-cta/yes-no-cta.module';
import { TrySomethingElseModule } from '../try-something-else/try-something-else.module';
import { VmReferAFriendModule } from '../vm-refer-a-friend/vm-refer-a-friend.module';
import { AnimationModule } from '../animation/animation.module';
import { LiveChatAgentSupportService } from '../../services/live-chat-support.service';
import { ModalWithLinkModule } from '../modal-with-link/modal-with-link.module';

// Use an empty object to meet StrapiGenericComponentService dependency
const authServiceMock = {
  initialise: {},
};

@NgModule({
  declarations: [DidThisHelpComponent],
  imports: [
    CommonModule,
    YesNoCtaModule,
    TrySomethingElseModule,
    VmReferAFriendModule,
    AnimationModule,
    ConfirmationModule,
    ModalWithLinkModule,
  ],
  exports: [DidThisHelpComponent],
  providers: [
    StrapiGenericComponentService,
    {
      provide: AuthService,
      useValue: authServiceMock,
    },
    LiveChatAgentSupportService,
  ],
})
export class DidThisHelpdModule {}
